export const ADD_PAYMENT_METHOD = 'ADD_PAYMENT_METHOD';
export const SAVE_PAYMENT_METHODS = 'SAVE_PAYMENT_METHODS';
